export default "__VITE_ASSET__BKugas6R__"